/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress/ProgressBarIndicator/ProgressBar/Content"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtProgressbarBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ProgressBar.borderColor.primary.base'
        })
let selectedFlowQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'flowQuestions',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.getCurrentProgress(selectedFlowQuestionsValueData, selectedAnswersValueData)
let dtProgressbarBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ProgressBar.backgroundColor.primary.base'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtProgressbarBordercolorPrimaryBase,'--w-2-Z1Yf8zk': isMedia.mobile ? "75%" : "85%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-3-Z1Yf8zk': dtProgressbarBackgroundcolorPrimaryBase,'--w-2-Z1Yf8zk': typeof aggregateData === 'number' ? `${aggregateData}px` : aggregateData,'--o-4-Z1Yf8zk': isBefore ? 0 : 1}}
 className={`views-block ${styles.Horizontal}`}
/>
</div>
{children}
</React.Fragment>)
}